import React from 'react';

import './HourText.scss';

const hourText = () => {
  
  const hours = [];
  for (let i = 1; i < 24; i++) {
    hours.push(
      <div key={i} className='hour-text'>
        {i === 0 ? '12AM' : i === 12 ? '12PM' : i < 12 ? i + 'AM' : (i - 12) + 'PM'}
      </div>
    );
  }
  
  return <div className='hour-text-container'>{hours}</div>;
};
export default hourText;
